// Subidas de la app que el back aún procesa en segundo plano (Files.ProcessingStatus): hasta que
// terminan no están en S3 y no se pueden abrir, descargar, mover ni renombrar.
export const FILE_PROCESSING_PENDING = 1;
export const FILE_PROCESSING_FAILED = 2;

export function fileNoteCell(row): string {
    if (row.processingStatus === FILE_PROCESSING_PENDING) return `${row.note} (procesando…)`;
    if (row.processingStatus === FILE_PROCESSING_FAILED) return `${row.note} (error al procesar)`;
    return `${row.note}`;
}

export class FileConst {
    public static headerTableWithOCR = [
        {
            field: 'type', title: 'Tipo', cell: (row) => ``, class: (row) => {
                switch (row.type) {
                    case 'Image': return `icon-photo`; break;
                    case 'PDF': return `icon-attachment`; break;
                    case 'Word': return `icon-text_format`; break;
                    case 'Excel': return `icon-grid_on`; break;
                    default: return `icon-folder`;
                }
            }
        },
        { field: 'note', title: 'Nombre', cell: (row) => fileNoteCell(row), class: (row) => `` },
        { field: 'date', title: 'Fecha', cell: (row) => `${new Date(row.date).toLocaleDateString() + " - " + new Date(row.date).toLocaleTimeString()}`, class: (row) => `` },
        {
            field: 'size', title: 'Tamaño', cell: (row) => {
                const result = parseFloat(row.size) / 1048576;
                const result2 = result.toFixed(2);
                return result2 + ' Mb';
            }, class: (row) => ``
        },
        {
            field: 'tipoGasto', title: 'Tipo Gasto', cell: (row) => {
                return row.tipoGasto;
            }, class: (row) => ``
        },
        {
            field: 'ocrStatusText', title: 'Gasto Generado (OCR)', cell: (row) => {
                switch (row.type) {
                    case 'Directory': return ``; break;
                    default: return `${row.ocrStatusText}`; break;
                }
            }, class: (row) => ``
        },
    ];

    public static headerTableWithoutOCR = [
        {
            field: 'type', title: 'Tipo', cell: (row) => ``, class: (row) => {
                switch (row.type) {
                    case 'Image': return `icon-photo`; break;
                    case 'PDF': return `icon-attachment`; break;
                    case 'Word': return `icon-text_format`; break;
                    case 'Excel': return `icon-grid_on`; break;
                    default: return `icon-folder`;
                }
            }
        },
        { field: 'note', title: 'Nombre', cell: (row) => fileNoteCell(row), class: (row) => `` },
        { field: 'date', title: 'Fecha', cell: (row) => `${new Date(row.date).toLocaleDateString() + " - " + new Date(row.date).toLocaleTimeString()}`, class: (row) => `` },
        {
            field: 'size', title: 'Tamaño', cell: (row) => {
                const result = parseFloat(row.size) / 1048576;
                const result2 = result.toFixed(2);
                return result2 + ' Mb';
            }, class: (row) => ``
        },
        {
            field: 'tipoGasto', title: 'Tipo Gasto', cell: (row) => {
                return row.tipoGasto;
            }, class: (row) => ``
        }
    ];
}
